// قفل تطبيق الموبايل بالبصمة أو الوجه (قرار المالك 03/10/2026: «عاوز الموظف يفتح التطبيق مرة وبعد كده يربطه ببصمة الوجه
// أو بصمة الموبايل، وبعد كده التطبيق يفضل شغّال عادي زي الواتساب بحيث يقدر يدخل عليه في أي وقت»).
//
// الجلسة نفسها تبقى (رمز التجديد يتجدّد 30 يومًا مع كل فتح) — والبصمة **بوّابة على الموبايل** لا كلمة مرور على الخادم:
// من يمسك الموبايل مفتوحًا لا يرى حجوزات الشركة إلا بوجه صاحبه أو بصمته. والبصمة نفسها لا تغادر الموبايل أبدًا (النظام
// يتحقّق ويقول نعم/لا فقط). في المتصفّح لا شيء هنا، وتطبيقٌ قديم بلا الإضافة يُتجاوز بصمت.
import { Capacitor } from '@capacitor/core';
import { isNativeApp } from './platform.ts';

const PREF = 'icontravel.bioLock';          // on | off — غيابه: لم يُسأل بعد
const HIDDEN_AT = 'icontravel.bioHiddenAt';
/**
 * بعد كم ثانية بعيدًا عن التطبيق يُطلب الوجه/البصمة — **ساعة** (قرار المالك 03/10/2026: «بعد ما يسيبه أكتر من دقيقة دي —
 * خلّيها أكتر من ساعة»). والفتح من جديد بعد إغلاقه يحكمه الشيء نفسه: رجوعٌ قبل الساعة لا يطلب شيئًا.
 */
export const RELOCK_SECONDS = 60 * 60;

const read = (k: string): string | null => { try { return localStorage.getItem(k); } catch { return null; } };
const write = (k: string, v: string | null) => { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch { /* لا تخزين */ } };

export type BioPref = 'on' | 'off' | null;
export const bioPref = (): BioPref => { const v = read(PREF); return v === 'on' || v === 'off' ? v : null; };
export const setBioPref = (v: BioPref) => write(PREF, v);

export const markHidden = () => write(HIDDEN_AT, String(Date.now()));
/** هل مرّ في الخلفية ما يكفي ليُقفل؟ */
export const awayLongEnough = (now = Date.now()): boolean => {
  const at = Number(read(HIDDEN_AT));
  return !at || now - at >= RELOCK_SECONDS * 1000;
};

/** هل في الموبايل بصمة أو وجه (أو قفل شاشة كبديل)؟ */
export async function bioAvailable(): Promise<boolean> {
  if (!isNativeApp() || !Capacitor.isPluginAvailable('NativeBiometric')) return false;
  try {
    const { NativeBiometric } = await import('@capgo/capacitor-native-biometric');
    return (await NativeBiometric.isAvailable({ useFallback: true })).isAvailable;
  } catch { return false; }
}

/** يفتح نافذة النظام للبصمة/الوجه — true لو تحقّق صاحبه */
export async function verifyBio(): Promise<boolean> {
  try {
    const { NativeBiometric, BiometryType } = await import('@capgo/capacitor-native-biometric');
    await NativeBiometric.verifyIdentity({
      title: 'iConTravel', subtitle: 'افتح بالبصمة أو الوجه أو قفل الموبايل', reason: 'افتح iConTravel',
      negativeButtonText: 'إلغاء', useFallback: true, maxAttempts: 5,
      /**
       * **وقفل الموبايل بديلًا** (المراجعة الشاملة الثالثة، والمالك 03/10/2026: «حل المشكلة»): على أندرويد `useFallback`
       * يُتجاهَل — فموبايلٌ برقمٍ سري أو نقشٍ فقط كانت «فعّلها» تفشل عنده دائمًا. أيّ بصمة/وجه **أو** قفل الشاشة.
       */
      allowedBiometryTypes: [BiometryType.MULTIPLE, BiometryType.DEVICE_CREDENTIAL],
    });
    return true;
  } catch { return false; }
}
